export enum ESousSubstrat {
    Sables = 1,
    Limons,
    Branchages,
    Racines,
    Dalles,
    Argile,
    Marnes,
    DebrisVegetaux,
    Galets,
    Pierres,
    Litieres,
    Algues
}